import Phaser from 'phaser';
import { Colors } from '../../consts/Colors';
import Card1 from '../game1/Card1';
import { Fonts } from '../../consts/Fonts';

export default class Card2 extends Card1 {
    constructor(scene, x, y, cardData) {
        cardData.name = "card2"
        super(scene, x, y, cardData);

        this.defaultStyle = {
            fontSize: "25px",
            fontFamily: Fonts.MassiliaRegular,
            color: Colors.Text.Black,
            lineSpacing: -1,
            letterSpacing: -0.5,
        }

        this.smallStyle = {
            fontSize: "15px",
            lineSpacing: 1,
            letterSpacing: 0
        }

        this.text = this.scene.add.rexTagText(-this.cardImage.width / 2 + 32, 0, cardData.text, this.defaultStyle).setOrigin(0, 0.5);
        this.add(this.text);

    }

    drop(){
        this.cardImage.setTexture(this.cardData.name + "_small")
        this.setTextStyle(this.smallStyle)
        this.text.setPosition(-this.cardImage.width / 2 + 16, 0)
        console.log("onDrop")
    }

    setDone() {
        this.isDone = true
        this.cardImage.setAlpha(0)
        this.setTextStyle(this.smallStyle)
        // this.text.setPosition(-this.cardImage.width / 2 + 16, 0)
    }

    setFalse(){
        this.cardImage.setTexture(this.cardData.name + "_false")
        this.text.setPosition(-this.cardImage.width / 2 + 16, 0)
    }

    setText(text) {
        this.text.setText(text);
    }

    setTextStyle(style){
        this.text.setStyle(style)
    }

    resetPosition(duration = 300) {
        super.resetPosition(duration)
        this.setTextStyle(this.defaultStyle)
        this.cardImage.setAlpha(1)
        this.cardImage.setTexture(this.cardData.name)
        this.text.setPosition(-this.cardImage.width / 2 + 32, 0)
    }
}